import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchInvestigationItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SearchInvestigationItemsQuery = { readonly __typename?: 'Query', readonly catalogueInvestigationActivities: ReadonlyArray<{ readonly __typename?: 'InvestigationActivityItem', readonly _id?: string | null, readonly title: string } | null> };


export const SearchInvestigationItemsDocument = gql`
    query searchInvestigationItems {
  catalogueInvestigationActivities {
    _id
    title
  }
}
    `;

/**
 * __useSearchInvestigationItemsQuery__
 *
 * To run a query within a React component, call `useSearchInvestigationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInvestigationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInvestigationItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchInvestigationItemsQuery(baseOptions?: Apollo.QueryHookOptions<SearchInvestigationItemsQuery, SearchInvestigationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInvestigationItemsQuery, SearchInvestigationItemsQueryVariables>(SearchInvestigationItemsDocument, options);
      }
export function useSearchInvestigationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInvestigationItemsQuery, SearchInvestigationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInvestigationItemsQuery, SearchInvestigationItemsQueryVariables>(SearchInvestigationItemsDocument, options);
        }
export type SearchInvestigationItemsQueryHookResult = ReturnType<typeof useSearchInvestigationItemsQuery>;
export type SearchInvestigationItemsLazyQueryHookResult = ReturnType<typeof useSearchInvestigationItemsLazyQuery>;
export type SearchInvestigationItemsQueryResult = Apollo.QueryResult<SearchInvestigationItemsQuery, SearchInvestigationItemsQueryVariables>;